import { Icon } from '@cb/apricot-react';

export default function EstEndTimeNotification() {
  return (
    <div className='d-flex align-items-start py-2' role='note' aria-label='Estimated end time information'>
      <div style={{ lineHeight: 1 }}>
        <Icon circular name='megaphone' size='24' decorative />
      </div>
      <p className='mb-0 ml-2 cb-font-weight-bold'>
        The estimated end time is calculated once for each student when they start. The estimate assumes students use
        their full time, including any extra time from accommodations. Actual ending times may vary.
      </p>
    </div>
  );
}
